import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=342784ed&scoped=true&"
import script from "./Backdrop.vue?vue&type=script&lang=ts&"
export * from "./Backdrop.vue?vue&type=script&lang=ts&"
import style0 from "./Backdrop.vue?vue&type=style&index=0&id=342784ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342784ed",
  null
  
)

export default component.exports